module.exports = __webpack_public_path__ + "static/img/img4.c6fe98a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img4.png
// module id = PCle
// module chunks = 1